import { getStatusClass } from "../../common/helper/transaction-status.component.js";
import useNavigation from "../../../hooks/useNavigation.js";
import MUIButton from "../../common/miui-component/mui-button.jsx";

export const gpColumn = (
  expanded,
  transferAmount,
  changeStatus,
  deleteMerchant
) => {
  const { navigateTo } = useNavigation();

  const checkStatus = (name,row) => {
    if(name == 'A') {

      return (<label className="switch"  style={{ padding: row.id && !!expanded[row.id] ? '0' : '3px' }} onClick={(event) => {
        event.preventDefault(); // Prevent the default action
        changeStatus(row); // Call your changeStatus function
      }}>
      <input type="checkbox" className="switch-input"  checked />
      <span className="switch-label" data-on="Active" data-off="Deactive" />
      <span className="switch-handle" />
    </label>)
    } else {
      return (

        <div data-tag="allowRowEvents"><label className="switch" onClick={(event) => {
          event.preventDefault(); // Prevent the default action
          changeStatus(row); // Call your changeStatus function
        }}><input type="checkbox" className="switch-input" /><span className="switch-label" data-on="Active" data-off="Deactive" /><span className="switch-handle" /></label></div>
      );
    }
}
  return [
    {
      name: "Name",
      cell: (row) => (
        <div className="custom-cell-merchant_name">
          {row.merchant_detail.merchant_name}
        </div>
      ),

      sortable: true,
    },
    {
      name: "App",
      selector: row => checkStatus(row.status_id, row),
      sortable: true,
    },
    {
      name: "Qr",
      selector: row => checkStatus(row.status_id, row),
      sortable: true,
    },
    {
      name: "Both",
      selector: row => checkStatus(row.status_id, row),
      sortable: true,
    },
    {
      name: "Actions",
      button: true,
      style: (row) => ({ zIndex: 0 }),
      cell: (row) => (
        <div>
          <MUIButton
            // btnOnClick={handleApplyFilters}
            btnLabel="Apply"
            btnStyle={{
              capitalize: "camelcase",
              backgroundColor: "#495a69",
              border: "1px solid #b1adadd9",
                color: "white",
              padding:"0px",
              "&:hover": {
                backgroundColor: "rgb(117 121 124 / 82%)",
              },
            }}
          />
        </div>
      ),
    },
  ];
};
